import React, { useEffect, useState } from 'react'

import { RecommendationRenderer } from '@app/components/renderers/RecommendationRenderer'

import { cloneDeep } from '@app/utils/cloneDeep'

import type { MonitoringsRecommendationDto } from '@app/api/routes/monitoringLists/dtos'
import type { UseContractorColumnParams, useRecommendationColumnReturn } from './types'

export const useRecommendationColumn = ({
  columns,
  onClickCell
}: UseContractorColumnParams): useRecommendationColumnReturn => {
  const [columnsWithRecommendation, setColumnsWithRecommendation] = useState(columns)
  const [columnRecommendationData, setColumnRecommendationData] = useState<MonitoringsRecommendationDto | null>()
  const [columnRunParametersId, setColumnRunParametersId] = useState<number>(0)

  useEffect(() => {
    const recommedationColumn = columns.find(column => column.key === 'recommendation')

    if (recommedationColumn) {
      recommedationColumn.render = (_, record) => <RecommendationRenderer recommendation={ record.recommendation } />
      recommedationColumn.onCell = data => ({
        onClick: () => {
          onClickCell()
          setColumnRecommendationData(data.recommendation)
          setColumnRunParametersId(data.runParametersId)
        }
      })
    }

    setColumnsWithRecommendation(cloneDeep(columns))
  }, [columns])

  return {
    columnRecommendationData,
    columnRunParametersId,
    columnsWithRecommendation
  }
}
